import React, { FC, ReactNode, useEffect, useRef, useState } from 'react'
import { GridWrapper, IndicatorWrapper, Dot } from './style'

interface IGrid {
  children: ReactNode
  repeat?: number
  styleGrid?: string
  stack?: boolean
}

const Grid: FC<IGrid> = ({ children, repeat, styleGrid, stack }) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [scrollIndex, setScrollIndex] = useState(0)
  const [itemCount, setItemCount] = useState(0)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768)
    checkMobile()

    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  useEffect(() => {
    if (!scrollRef.current || stack) return

    const el = scrollRef.current
    const handleScroll = () => {
      const scrollLeft = el.scrollLeft
      const childWidth = el.children[0]?.clientWidth || 1
      const index = Math.round(scrollLeft / childWidth)
      setScrollIndex(index)
    }

    setItemCount(el.children.length)

    el.addEventListener('scroll', handleScroll)
    return () => el.removeEventListener('scroll', handleScroll)
  }, [stack, children])

  return (
    <>
      <GridWrapper
        ref={scrollRef}
        repeat={repeat || 4}
        styleGrid={styleGrid}
        stack={stack}
      >
        {children}
      </GridWrapper>

      {/* Show dots only if mobile, not stacked, and multiple items */}
      {!stack && isMobile && itemCount > 1 && (
        <IndicatorWrapper>
          {Array.from({ length: itemCount }).map((_, i) => (
            <Dot key={i} active={i === scrollIndex} />
          ))}
        </IndicatorWrapper>
      )}
    </>
  )
}

export default Grid
